import { createSlice } from "@reduxjs/toolkit";

export const configurationSlice = createSlice({
  name: "setUp",
  initialState: {
    initConnectedUser: null,
    userInformations: null,
    currentConnectedStream: null,
    currentTeamMember: null,
    currentTeamMemberData: null,
    currentConversation: null,
  },
  reducers: {
    initConnectedUser: (state, action) => {
      state.initConnectedUser =  action.payload;
    },
    setUserInformations: (state, action) => {
      state.userInformations = action.payload;
    },
    setCurrentConnectedStream: (state, action) => {
      state.currentConnectedStream = action.payload;
    },
    onCurrentTeamMember: (state, action) => {
      state.currentTeamMember = action.payload;
    },
    onCurrentTeamMemberData: (state, action) => {
      state.currentTeamMemberData = action.payload;
    },
    setCurrentConversation: (state, action) => {
      state.currentConversation = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase("SYNC/setInitConf", (state, action) => {
      return action.payload;
    });
  },
});
